import React from 'react';
import { ApplicationView, useController } from '@aha-app/mvc';
import AssistantViewController from './AssistantViewController';
import Raft from '../Raft/Raft';
import PromptPanel from '../PromptPanel/PromptPanel';
import styles from './AssistantView.module.css';
import SuggestionsPanel from '../SuggestionsPanel/SuggestionsPanel';
import HeaderPanel from '../HeaderPanel/HeaderPanel';
import HeaderButtons from '../HeaderPanel/HeaderButtons';
import ConversationPanel from '../ConversationPanel/ConversationPanel';
import ArtifactPanel from '../ArtifactPanel/ArtifactPanel';
import ToolPanel from '../ToolPanel/ToolPanel';
import ImagePopover from '../ConversationPanel/ImagePopover';
import classNames from 'classnames';

const AssistantContainer = ({ children }) => {
  const handleBlur = e => {
    // TODO: This needs to be based on a click outside the assistant rather
    // than blurring which is to easy to get wrong.
    // controller.actionResizeByTrigger('blur');
  };

  return (
    <div className={styles.container} onBlur={e => handleBlur(e)}>
      {children}
    </div>
  );
};

const ConversationContent = ({ children }) => {
  const controller = useController(AssistantViewController);
  const { model, dock, readOnly } = controller.state;

  return (
    <div
      className={classNames(styles.conversationContent, {
        [styles.conversationEmptyInMiddle]:
          model.emptyChat && ['full-screen', 'full-page'].includes(dock),
        [styles.conversationAtTop]: readOnly,
      })}
      onClick={() => controller.actionResizeByTrigger('click-conversation')}
    >
      {children}
    </div>
  );
};

const ConversationColumn = ({ children }) => (
  <div className={styles.conversationColumn}>{children}</div>
);

const Columns = ({ children }) => (
  <div className={styles.columns}>{children}</div>
);

const StickyBottom = ({ children, size }) => (
  <div
    className={classNames(styles.stickyBottom, {
      [styles.stickyBottomNoBackground]: size === 'toolbar',
    })}
  >
    {children}
  </div>
);

const AssistantView = () => {
  const controller = useController(AssistantViewController);
  const { size, readOnly, model, currentImageAttachment } = controller.state;

  return (
    <Raft size={size}>
      <AssistantContainer>
        {size !== 'side-panel' && <HeaderPanel />}
        <Columns>
          {['full-page'].includes(size) && !readOnly && <HeaderButtons />}
          {!readOnly && <ToolPanel />}
          <ConversationColumn>
            <ConversationContent>
              {!model.emptyChat && <ConversationPanel />}
              <StickyBottom size={size}>
                {!readOnly && <PromptPanel />}
                {model.emptyChat && <SuggestionsPanel />}
              </StickyBottom>
            </ConversationContent>
          </ConversationColumn>
          <ArtifactPanel />
        </Columns>
      </AssistantContainer>

      {currentImageAttachment && (
        <ImagePopover
          attachment={currentImageAttachment}
          onClose={() => controller.actionCloseImageAttachment()}
        />
      )}
    </Raft>
  );
};

export default ApplicationView(AssistantView);
